export const SET_CAMPAIGN = "SET_CAMPAIGN";
export const SET_CAMPAIGN_RULES = "SET_CAMPAIGN_RULES";
export const SET_CAMPAIGN_STEPS = "SET_CAMPAIGN_STEPS";
export const SET_CAMPAIGN_BASE_RULES = "SET_CAMPAIGN_BASE_RULES";
export const RESET_CAMPAIGN_RULES = "RESET_CAMPAIGN_RULES";
export const RESET_CAMPAIGN_STATE = "RESET_CAMPAIGN_STATE";
